export const CLINIC_ADMIN = 'CLINIC_ADMIN';                       // Clinic admin
export const CLINIC_USER = 'CLINIC_USER';                         // Clinic base user
